export const TOAST_MESSAGES = {
  ADD_LEAVE: "Leave Added Successfully",
  FAILED_ADD_LEAVE: "Failed to add leave",
  FETCH_LEAVES: "Leaves fetched successfully",
  FAILED_FETCH_LEAVES: "Failed to fetch leaves",
  DELETE_LEAVE: "Leave deleted successfully",
  FAILED_DELETE_LEAVE: "Failed to delete leave",
  NO_RESPONSE_DATA: "Data not available",
  LEAVE_UPDATE_SUCCESS: "Leave Updated Successfully",
  LEAVE_UPDATE_FAILED: "Failed to update Leave Request",
  FAILED_TO_FETCH_DETAILS: "Failed to fetch details",
  APPROVAL_SUCCESS: "Leave Approved",
  LEAVE_REJECTED: "Leave Rejected",
  APPROVAL_FAILED: "Failed to approve",
  USER_FETCH_ERROR: "Failed to fetch users",
  FAILED_TO_REFRESH: "Failed to refresh leave summary.",
  REFRESH_SUCCESS: "Monthly leave summary refreshed!",
  LEAVE_CREDIT_SUCCESS: "Leave credited successfully",
  LEAVE_DEBIT_SUCCESS: "Leave debited successfully",
  LEAVE_CREDIT_FAILED: "Failed to credit leave",
  LEAVE_DEBIT_FAILED: "Failed to debit leave",
  FAILED_FETCH_SUMMARY: "Failed to fetch leave summary",
  RESTRICT_PAST_MONTH_SUMMARY: "Cannot refresh summary for past months.",
  SUMMARY_NOT_CREATED:
    "Summary not created, salary already calculated for this user for selected month",
};

export const LEAVE_REQUEST_VALIDATION_MESSAGES = {
  USER: "User is required",
  CATEGORY: "Category is required",
  START_DATE: "Start date is required",
  END_DATE: "End date is required",
  REASON: "Reason is required",
  LEAVE_CREDIT_TYPE: "Type is required",
  LEAVE_CREDIT_COUNT: "Count is required",
  MONTH: "Month is required",
  LEAVE_DATE_REQUIRED: "Please select at least one leave date",
}

export const LEAVE_CALENDAR_TABLE_COLUMNS = [
  "date",
  "description",
  "note",
  "actions",
];

export const LEAVE_CALENDAR_COLUMN_LABELS = {
  date: "Leave Date",
  description: "Description",
  note: "Note",
  actions: "Actions",
};

export const transformLeaveData = (input) => {
  const COLORS = [
    "#4F46E5",
    "#EC4899",
    "#10B981",
    "#F59E0B",
    "#6366F1",
    "#14B8A6",
    "#EF4444",
    "#8B5CF6",
  ];

  return input.map((item) => {
    const fullTitle = item.note || item.description || "Holiday";

    // truncate if too long
    const shortTitle =
      fullTitle.length > 20 ? fullTitle.slice(0, 17) + "..." : fullTitle;

    // consistent color based on id
    const colorIndex = item.id % COLORS.length;
    const bgColor = COLORS[colorIndex];

    return {
      id: item.id,
      title: shortTitle,
      start: item.date,
      backgroundColor: bgColor,
      borderColor: "white",
      textColor: "white",
      extendedProps: {
        fullTitle, // for tooltip
        description: item.description,
        note: item.note,
      },
    };
  });
}

//Leave Requests

export const LEAVE_REQUEST_TABLE_COLUMNS = [
  "user_name",
  "category",
  "is_half_day",
  "start_date",
  "end_date",
  "status",
  "created",
  "actions",
];

export const LEAVE_REQUEST_COLUMN_LABELS = {
  user_name: "User",
  start_date: "Start Date",
  end_date: "End Date",
  status: "Status",
  created: "Leave Applied On",
  category: "Category",
  actions: "Actions",
  is_half_day: "Is Half Day"
};

export const LEAVE_REQUEST_STATUS = {
  PENDING_L1_APPROVAL: "PENDING_L1_APPROVAL",
  PENDING_L2_APPROVAL: "PENDING_L2_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
};

export const LEAVE_REQUEST_STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Pending L1 Approval", value: "PENDING_L1_APPROVAL" },
  { label: "Cancelled", value: "CANCELLED" },
];

export const LEAVE_CATEGORY_OPTIONS = [
  { label: "Sick Leave", value: "SICK" },
  { label: "Paid Leave", value: "PAID" },
  { label: "Floating Leave", value: "FLOATING" },
  { label: "Compensation", value: "COMPENSATION" },
  { label: "Maternity Leave", value: "MATERNITY" },
  { label: "Paternity Leave", value: "PATERNITY" },
];

export const LEAVE_REQUEST_MODE = {
  VIEW: "view",
  ADD: "add",
  EDIT: "edit"
}

export const LEAVE_SUMMARY_COLUMNS = [
  "user",
  "category",
  "month",
  "earned_leaves",
  "approved_leaves",
  "balance",
];

export const LEAVE_SUMMARY_COLUMN_LABELS = {
  user: "User",
  category: "Category",
  month: "Month",
  earned_leaves: "Earned Leaves",
  approved_leaves: "Approved Leaves",
  balance: "Balance",
};

export const LEAVE_CREDIT_DEBIT_COLUMNS = [
  "user",
  "category",
  "leave_credit_type",
  "leave_credit_count",
  "month",
  "actions",
];

export const LEAVE_CREDIT_DEBIT_COLUMN_LABELS = {
  user: "User",
  month: "Month",
  category: "Category",
  leave_credit_type: "Type",
  leave_credit_count: "Count",
  actions: "Actions",
};

export const LEAVE_CREDIT_TYPES = [
  { value: "CREDIT", label: "Credit" },
  { value: "DEBIT", label: "Debit" }
]

export const creditTypeCSS = {
  CREDIT: "bg-green-100 text-green-700",
  DEBIT: "bg-red-100 text-red-700",
};

